import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withDebugTracing } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatDialog } from '@angular/material/dialog';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { AuthModule } from 'angular-auth-oidc-client';
import { openIdConfig } from './auth-config';
import { authInterceptor } from './auth/auth.interceptor';
import { LoadingService } from './services/loading.service';
import { LocalStorageService } from './services/local.service';
import { LanguageService } from './services/language.service';
import { TranslateService, TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, TRANSLATE_HTTP_LOADER_CONFIG } from '@ngx-translate/http-loader';
import { RouteAuditTrackerService } from './services/audit-tracker.service';
import { provideAppInitializer, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding(), withDebugTracing()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),

    // OpenID Connect
    importProvidersFrom(
      AuthModule.forRoot({
        config: openIdConfig,
      })
    ),

    // i18n
    importProvidersFrom(
      TranslateModule.forRoot({
        fallbackLang: 'pt',
        loader: {
          provide: TranslateLoader,
          useClass: TranslateHttpLoader
        }
      })
    ),
    TranslateService,
    { provide: TRANSLATE_HTTP_LOADER_CONFIG, useValue: { prefix: 'assets/i18n/', suffix: '.json' } },

    provideAppInitializer(() => {
      const translate = inject(TranslateService);
      const language = inject(LanguageService);
      return initTranslations(translate, language)();
    }),
    provideAppInitializer(() => {
      const auditTracker = inject(RouteAuditTrackerService);
      return initAuditTracker(auditTracker)();
    }),
    MatDialog,
    LoadingService,
    LocalStorageService,
  ]
};

export function initTranslations(translate: TranslateService, languageService: LanguageService) {
  return () => {
    translate.addLangs(['pt', 'en', 'es']);
    translate.use(languageService.currentLang);
  };
}

export function initAuditTracker(auditTracker: RouteAuditTrackerService) {
  return () => {
    auditTracker.init();
  };
}